import React from 'react';
import { Link } from 'react-router-dom';
import stadiumLogo from '../assets/images/stadium2_Mesa_de_trabajo_1.jpeg'; // Import the new logo
import './Footer.css'; // Import the CSS file

const Footer = () => {
  return (
    <footer className="py-4 bg-dark">
      <div className="container text-center">
        <img src={stadiumLogo} alt="Stadium Games Logo" className="footer-logo mb-3" />
        <p>&copy; 2025 Stadium Games. All Rights Reserved.</p>
        <ul className="list-inline">
          <li className="list-inline-item">
            <Link to="/press-kit">Press Kit</Link>
          </li>
          <li className="list-inline-item">
            <Link to="/contact">Contact</Link>
          </li>
          <li className="list-inline-item">
            <Link to="/privacy-policy">Privacy Policy</Link>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
